import { createSvgIcon } from '@automata/mui-theme';
export const PickUpCapsIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path d="M50.115 16.1213L35.9729 30.2635L33.8516 28.1421L47.9937 14L50.115 16.1213Z" />
    <path d="M48.0061 14.0002L62.1483 28.1424L60.0269 30.2637L45.8848 16.1215L48.0061 14.0002Z" />
    <path d="M46.5 17.7832H49.5V43.7832H46.5V17.7832Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34 50.7832V67.7832H62V50.7832H34ZM33 47.7832C31.8954 47.7832 31 48.6786 31 49.7832V68.7832C31 69.8878 31.8954 70.7832 33 70.7832H63C64.1046 70.7832 65 69.8878 65 68.7832V49.7832C65 48.6786 64.1046 47.7832 63 47.7832H33Z"
    />
    <path d="M38 50.7832H40V68.7832H38V50.7832Z" />
    <path d="M44 50.7832H46V68.7832H44V50.7832Z" />
    <path d="M50 50.2832H52V68.2832H50V50.2832Z" />
    <path d="M56 49.7832H58V67.7832H56V49.7832Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 74.7832V79.7832H77V74.7832H80V82.7832H16V74.7832H19Z"
    />
  </svg>,
  'PickUpCapsIcon'
);
